
































































// @ts-nocheck

import Vue from "vue"
import {pr} from "@/helpers/functions"
import apidb from "@/providers/apidb"
import apiip from "@/providers/apiip"
import apiflag from "@/providers/apiflag"

import {get_obj_entity, config, get_obj_detete} from "@/modules/ipblacklist/queries"
import get_filters from "@/helpers/filter"

import progressbar from "@/components/common/bars/progress_bar.vue"
import notisuccess from "@/components/common/notifications/notification_success.vue"
import notierror from "@/components/common/notifications/notification_error.vue"
import noticonfirm from "@/components/common/notifications/notification_confirm.vue"

export default Vue.extend({

  name: "ipblacklist-detail",

  components:{
    progressbar,
    notisuccess,
    notierror,
    noticonfirm,
  },

  props:{
    //si se muestra el form
    isvisible: Boolean,
    objrow: Object,
  },

  data: ()=>(
    {
      isconfirm: false,
      issubmitting: false,
      error:{title:"",message:""},
      success:{title:"",message:""},
      objrowform:{},
      objflag:{},
      blockdate:{
        full: "",
      },
    }
  ),

  //getters
  computed:{
    
    get_dialogtitle(): string {return `Nº:${this.objrowform.id} - IP: ${this.objrowform.remote_ip}`},

    is_visible:{
      get(): boolean {return this.isvisible},
      set(v: any){}
    },

    is_submitting(){
      return this.issubmitting
    },

  },
  
  created(){
    console.log("detail.creatd",this.objrow)
    this.objrowform = {...this.objrow}
    ;this.async_detail()
  },

  watch:{
    isvisible: function(curr,old){
      if(curr==true){
        this.objrowform = {...this.objrow}
      }
      console.log("detail.watch.isvisible",this.objrowform)
    }
  },

  //setters 
  methods:{

    set_objrowform(objrow){ this.objrowform = {...objrow}},

    set_error(title,message){
      this.error.title = title
      this.error.message = message
    },

    set_success(title,message){
      this.success.title = title
      this.success.message = message
    },    

    reset_alerts(){
      this.set_error("","")
      ;this.set_success("","")
    },

    close(){
      console.log("detail.close.close",this.objrowform)
      this.objrowform = {}
      this.objflag = {}
      ;this.reset_alerts()
      ;this.$emit("evtclose")
    },
    show_confirm(){
      this.isconfirm = true
    },
    async_detail: async function (){
      this.reset_alerts()
      this.issubmitting = true

      const objparam = {
        filters:{
          op: "AND",
          fields:[{field:"bl.id", value:this.objrowform.id}]
        }
      }
      const objquery = get_obj_entity(objparam)
      const result = await apidb.async_get_list(objquery)
      //alert(JSON.stringify(this.objrowform))
      const flag = await apiflag.async_getflags([this.objrowform])
      this.objflag = {...flag[0]}

      this.issubmitting = false
      if(result.error){
        this.set_error("Error",result.error)
        ;this.$emit("evtrefresh","nok")
        return
      }

      if(!result.result[0]){
        this.set_error("Error","No result")
        ;this.$emit("evtrefresh","nok")
        return
      }

      ;this.set_objrowform(result.result[0])
      ;this.set_success("Success",`Reg refreshed ${this.objrowform.id}`)
      ;this.$emit("evtrefresh","ok")
    },// async

    async_unban: async function (option){
      this.isconfirm = false
      //pr(option)
      if(option!=="accept") return
      this.issubmitting = true
      
      const objparam={
        fields: this.objrowform,
        keys:["id"]
      }
      
      const objquery = get_obj_detete(objparam)
      const result = await apidb.async_delete(objquery)
      ;this.$emit("evtdelete","ok") //refresca el grid
      ;this.$emit("evtclose","ok") //cierra el form
      this.issubmitting = false
      await this.async_refresh()

    }// async_unban

  }//methods

})//vue
